import { render, staticRenderFns } from "./ltvGameData.vue?vue&type=template&id=097b146b&"
import script from "./ltvGameData.vue?vue&type=script&lang=js&"
export * from "./ltvGameData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/www/game/xcp-vue-xcll/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('097b146b')) {
      api.createRecord('097b146b', component.options)
    } else {
      api.reload('097b146b', component.options)
    }
    module.hot.accept("./ltvGameData.vue?vue&type=template&id=097b146b&", function () {
      api.rerender('097b146b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/xcpGameData/ltvGameData.vue"
export default component.exports